import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    console.log("constantdatadum", data?.practisingSensibleEconomicsSiderData);
    fields = {
        practisingSensibleEconomicsSiderData: data?.practisingSensibleEconomicsSiderData?.map((data: ModuleFields[])=>{
                return mapFields(data);
        }),
        practisingSensibleEconomicsFeatures: data?.practisingSensibleEconomicsFeatures?.map((data: ModuleFields[])=>{
          return mapFields(data);
  }),
        practisingSensibleEconomicsMainContent: mapFields(data?.practisingSensibleEconomicsMainContent),
    };
    console.log("constantsdum-maincontent", fields);
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
